import React, { useEffect, useState, useMemo } from "react";
import { createPointsGame } from "../../services/pointsGameService";
import { getMatches } from "../../services/matchService";
import { getLeagues } from "../../services/leagueService";
import { getSectionQuestions } from "../../services/sectionQuestionsService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const AddGamesPointsLayer = () => {
  const navigate = useNavigate();

  const [leagues, setLeagues] = useState([]);
  const [matches, setMatches] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    league_id: "",
    match_id: "",
    question: "",
    entry_amount: "50", // default
    admin_percentage: "20", // default
    user_distribution_percentage: "5", // default
    status: "active",
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const [leagueRes, matchRes, secRes] =
      await Promise.all([
        getLeagues(),
        getMatches(),
        getSectionQuestions("B"),
      ]);

    if (leagueRes?.status) setLeagues(leagueRes.data);
    if (matchRes?.status) setMatches(matchRes.data);
    if (secRes?.status) setQuestions(secRes.data);
  };

  const leagueMatches = useMemo(() => {
    if (!form.league_id) return [];
    return matches.filter(
      (m) => String(m.league_id) === String(form.league_id)
    );
  }, [form.league_id, matches]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.league_id || !form.match_id || !form.question) {
      toast.error("All required fields");
      return;
    }

    try {
      setLoading(true);

      const res = await createPointsGame({
        league_id: form.league_id,
        match_id: form.match_id,
        question: form.question,
        entry_amount: Number(form.entry_amount),
        admin_percentage: Number(form.admin_percentage),
        user_distribution_percentage: Number(
          form.user_distribution_percentage
        ),
        status: form.status,
      });

      if (res?.status) {
        toast.success("Game Created");
        navigate("/games-points-list");
      } else {
        toast.error(res?.msg);
      }
    } catch {
      toast.error("Server error");
    }

    setLoading(false);
  };

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="fw-bold mb-3">Add Points Game</h4>

          <form onSubmit={handleSubmit} className="row g-3">

            <div className="col-12 col-md-6">
              <label className="form-label">League</label>
              <select
                className="form-select"
                name="league_id"
                value={form.league_id}
                onChange={handleChange}
              >
                <option value="">Select League</option>
                {leagues.map((l) => (
                  <option key={l.id} value={l.id}>
                    {l.league_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12 col-md-6">
              <label className="form-label">Match</label>
              <select
                className="form-select"
                name="match_id"
                value={form.match_id}
                onChange={handleChange}
              >
                <option value="">Select Match</option>
                {leagueMatches.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.team_a} vs {m.team_b}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12">
              <label className="form-label">Question</label>
              <select
                className="form-select"
                name="question"
                value={form.question}
                onChange={handleChange}
              >
                <option value="">Select Question</option>
                {questions.map((q) => (
                  <option key={q.id} value={q.question}>
                    {q.question}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-6 col-md-4">
              <label className="form-label">Entry</label>
              <select
                className="form-select"
                name="entry_amount"
                value={form.entry_amount}
                onChange={handleChange}
              >
                {[50, 100, 250, 500].map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-6 col-md-4">
              <label className="form-label">Admin %</label>
              <select
                className="form-select"
                name="admin_percentage"
                value={form.admin_percentage}
                onChange={handleChange}
              >
                {[20, 30, 40, 50].map((v) => (
                  <option key={v} value={v}>
                    {v}%
                  </option>
                ))}
              </select>
            </div>

            <div className="col-6 col-md-4">
              <label className="form-label">Winner %</label>
              <select
                className="form-select"
                name="user_distribution_percentage"
                value={form.user_distribution_percentage}
                onChange={handleChange}
              >
                {[5, 6, 7, 8, 9, 10].map((v) => (
                  <option key={v} value={v}>
                    {v}%
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12">
              <button
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? "Creating..." : "Create Game"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};